import { getOdinResourceIdMap } from '@/config/odinResourceIds'
import { getOdinData,formatOdinData } from "@/request/odinRequest"

var mpId = window?.pcArticleInfo?.newsId
var channelId = window?.pcArticleInfo?.channelId

// 获取推荐数据
export const recListApi = async function (opts) {
    const spmObj = window?.sohuSpm?.getCodes()
    const senceKey = 'recommendVideoFeed'
    const idsMap = getOdinResourceIdMap(senceKey)
    const params = {
        tplCompKey: senceKey,
        adInfo: idsMap?.adInfo,
        spmCCode: idsMap?.spmCCode,
        resourceId: idsMap?.resourceId,
        content: {
            page: opts.page,
            size: opts.size,
            productId: idsMap?.productId,
            productType: idsMap?.productType,
            spm: `${spmObj?.a}.${spmObj?.b}.${idsMap?.spmCCode}`
        },
        context: {
            mkey: 'channelId_' + window.pcArticleInfo?.channel_id + '--mpid_' + window.pcArticleInfo?.news_id
        }
    }
    const res = await getOdinData(params)
    if(res?.list?.length) {
        let list = formatOdinData(res) || []
        list = formatData(list)
        return list
    } else {
        return []
    }
}
// 获取热门视频
export const getHotList = async function (opts) {
    try {
        const spmObj = window?.sohuSpm?.getCodes()
        const senceKey = 'hotVideoFeed'
        const idsMap = getOdinResourceIdMap(senceKey)
        const params = {
            tplCompKey: senceKey,
            adInfo: idsMap?.adInfo,
            spmCCode: idsMap?.spmCCode,
            resourceId: idsMap?.resourceId,
            content: {
                page: opts.page,
                size: opts.size,
                productId: idsMap?.productId,
                productType: idsMap?.productType,
                spm: `${spmObj?.a}.${spmObj?.b}.${idsMap?.spmCCode}`
            },
            context: {
                mkey:`channelId_${window.pcArticleInfo?.channel_id}--mpid_${window.pcArticleInfo?.news_id}`
            }
        }
        const res = await getOdinData(params)
        if(res?.list?.length) {
            let list = formatOdinData(res) || []
            list = formatData(list)
            return list
        } else {
            return []
        }
    } catch (error) {
        return []
    }
}
const formatData = function(list) {
    if(!list.length) return []
    list.forEach((item)=>{
            // 如果是视频类型
            if (item.businessType == 1 && (item.contentType == 4 || item.contentType == 5) ) {
                item.isVideo = true;
                item.videoDuration = item?.videoInfoDTO?.smartDuration;
            }
            if (item.contentType === 3) item.isPicture = true;// type:3展示为图集类型
            if (item.contentType === 4) {// type:4 展示为大图视频类型
                item.hasVideoTag = true;// 是否有视频按钮
                item.isBigVideoStyle = true;// 是否大图展示
                item.dataMeasure = {
                    type: '',
                    value: '',
                };
            }
            if (item.contentType === 5) {// type: 5 展示为视频图文类型
                item.hasVideoTag = true;// 是否有视频标签
            }
            item.id = item.newsId || item.id; //兼容feedlist组件，同时给予id和newsId
            //若存在laobel或者tag标签
            if (item?.label?.comments === '精选') {
                var _color = item.label.color;
                item.tag = {
                    name: item.label.comments,
                    borderColor: _color || '#F5D795',
                    textColor: _color || '#FDBE00',
                };
            }
        
    })
    return list
}